import React from 'react';
import FamewallEmbed from 'react-famewall';

interface LazyLoadedFamewallProps {
    wallUrl: string;
    carouselMode: boolean;
}

const LazyLoadedFamewall = (props:LazyLoadedFamewallProps) => {
    const [loadFamewall, setLoadFamewall] = React.useState(false);
    const famewallContainerRef = React.useRef(null);
    const { wallUrl, carouselMode } = props;

    React.useEffect(() => {
        const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
            setLoadFamewall(true);
            observer.disconnect();
            }
        },
        {
            threshold: 0.1
        }
        );

        observer.observe(famewallContainerRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="w-full" ref={famewallContainerRef}>
            {loadFamewall ? <FamewallEmbed wallUrl={wallUrl} carouselMode={carouselMode}/> : <div>Loading...</div>}
        </div>
    );
}

export default LazyLoadedFamewall;
